// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x3cV","label":"styles_label__HoDMn"};